import React, { useState, useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import ReactInputVerificationCode from "react-input-verification-code";
import cookies from "js-cookie";
import { useTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getOneUser,
  getOneUserWithToken,
} from "../../redux/actions/usersActions";
import notify from "../../hook/useNotification";
import { ToastContainer } from "react-toastify";
import { addProductToCart, storeNotLoginCartInBackEnd } from "../../redux/actions/cartAction";
import LoadingSpinner from "../../Components/Utilities/LoadingSpinner";

const UserVerify = () => {
  const { t } = useTranslation();

  const currentLanguageCode = cookies.get("i18next") || "en";
  const isRTL = currentLanguageCode === "ar";

  const settingsRes = useSelector((state) => state.settingsReducers.settings);
  const webSiteData = useSelector((state) => state.settingsReducers.webSiteData);
  const dispatch = useDispatch();
  const { id } = useParams();
  const [value, setValue] = useState("");
  const clearValue = () => setValue("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const get = async () => {
      await dispatch(getOneUser(id));
    };
    get();
  }, []);

  const res = useSelector((state) => state.usersReducers.oneUser);

  // console.log('res');
  // console.log(res);

  // console.log('webSiteData');
  // console.log(webSiteData);

  console.log('res',res);

  const handlePressed = async () => {

    // let reversedValue=value.toString().split("").reverse().join("");
    //console.log(reversedValue);
    //return;

    if (res.verifiedCode == value) {
      setLoading(true);
      await dispatch(getOneUserWithToken(id));
      setLoading(false);
    } else {
      notify(t("incorrect code"), "error");
    }
  };
  const resToken = useSelector((state) => state.usersReducers.oneUserToken);

  useEffect(() => {

    const get=async()=>{
       const cartItems=JSON.parse(localStorage.getItem('cart'));
       await dispatch(storeNotLoginCartInBackEnd({items:cartItems,user:res}));

       console.log('after dispatch');

        setTimeout(() => {
          if (resToken.role === "admin") {
            window.location.href = "/admin/products";
          } else {
            window.location.href = "/";
          }
        }, 1500);

    }

    if (loading === false) {
      if (resToken.token) {
        localStorage.setItem("token", resToken.token);
        localStorage.setItem("user", JSON.stringify(resToken));
        notify(t("login success"), "success");

        // خد ال cart من ال local storage وسجله
        if(settingsRes?.data?.hasNotLoginCart==true){
            get();
          
        }
        else{
            
        setTimeout(() => {
          if (resToken.role === "admin") {
            window.location.href = "/admin/products";
          } else {
            window.location.href = "/";
          }
        }, 1500);
        }
        
      
      }
    }
  }, [loading]);

  return (
    <Container style={{ minHeight: "670px" }}>
      <Row className="py-5 d-flex justify-content-center ">
        <label
          className="mx-auto title-login my-4"
          style={{ textAlign: "center" }}
        >
          {t("enter verification code")}
        </label>

        {/* <p style={{ textAlign: "center" }}>{res.verifiedCode}</p> */}
        {
         
          webSiteData.SMS_DEVELOPMENT == 'true' && <p style={{ textAlign: "center" }}>{res.verifiedCode}</p>
            
        }
        
        
        <div style={{width:'auto'}} className={isRTL ? "otp-input-rtl" : ""}>
        <ReactInputVerificationCode
          placeholder=""
          onChange={setValue}
          value={value}
        />
        </div>
       
        <div className="py-5 d-flex justify-content-center">
          <button
            onClick={handlePressed}
            className="btn-save d-inline mt-2 mx-2"
            style={{ backgroundColor: settingsRes?.data?.primaryColor }}
            disabled={value.length === 4 ? false : true}
          >
           {!loading ? <LoadingSpinner /> : t("verify")}
          </button>
          <button
            onClick={clearValue}
            className="btn-save d-inline mt-2 "
            style={{ backgroundColor: settingsRes?.data?.primaryColor }}
          >
            {t("delete")}
          </button>
        </div>
      </Row>
      <ToastContainer />
    </Container>
  );
};

export default UserVerify;
